var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 7.5,
    stroke: "#0B0C0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 7.6665H14.0834M4.16675 7.6665H10.5834H4.16675Z",
    stroke: "#0B0C0E",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 12.3335H5.91675M15.8334 12.3335H9.41675H15.8334Z",
    stroke: "#0B0C0E",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 9.4165C13.2998 9.4165 14.0833 8.633 14.0833 7.6665C14.0833 6.70001 13.2998 5.9165 12.3333 5.9165C11.3668 5.9165 10.5833 6.70001 10.5833 7.6665C10.5833 8.633 11.3668 9.4165 12.3333 9.4165Z",
    stroke: "#0B0C0E",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66675 14.0835C6.70025 14.0835 5.91675 13.3 5.91675 12.3335C5.91675 11.367 6.70025 10.5835 7.66675 10.5835C8.63325 10.5835 9.41675 11.367 9.41675 12.3335C9.41675 13.3 8.63325 14.0835 7.66675 14.0835Z",
    stroke: "#0B0C0E",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFilter);
export default __webpack_public_path__ + "static/media/menu-filter.b4483481ad71709d8cb85ad3e584ffd8.svg";
export { ForwardRef as ReactComponent };